import { parseISO } from "date-fns";
import { useState, useEffect } from "react";
import { RouteComponentProps } from "react-router-dom";
import { CustomResourceRouteParams } from "../types";

export const useDriverLogViewParameters = (
  props: Partial<RouteComponentProps<CustomResourceRouteParams>>
) => {
  const [driverId, setDriverId] = useState<number>();
  const [logDate, setLogDate] = useState<Date>();

  useEffect(() => {
    if (!props.match?.params.id) {
      return;
    }

    if (!props.match?.params.driverId) {
      return;
    }

    const date = new Date(parseISO(props.match.params.id));
    const id = parseInt(props.match.params.driverId);

    if (isNaN(id)) {
      console.error("Driver ID is not a number");
      return;
    }

    if (driverId !== id) {
      setDriverId(id);
    }

    if (logDate?.getTime() !== date.getTime()) {
      setLogDate(date);
    }
  }, [props.match, driverId, logDate]);

  return { driverId, logDate };
};
